import { render, staticRenderFns } from "./TripartiteLoan.vue?vue&type=template&id=0ed08a1e&scoped=true"
import script from "./TripartiteLoan.vue?vue&type=script&lang=js"
export * from "./TripartiteLoan.vue?vue&type=script&lang=js"
import style0 from "./TripartiteLoan.vue?vue&type=style&index=0&id=0ed08a1e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed08a1e",
  null
  
)

export default component.exports